import { render } from "./submissionLo.vue?vue&type=template&id=c8c57770"
import script from "./submissionLo.vue?vue&type=script&lang=js"
export * from "./submissionLo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__